import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Menu, PageHeader, Layout, Spin } from 'antd'
import {
	FormOutlined,
	NodeIndexOutlined,
	DeploymentUnitOutlined,
	EditOutlined,
	ArrowUpOutlined,
	FileTextOutlined,
} from '@ant-design/icons'
import { useLocation } from 'react-router-dom'

import BreadCrumb from '~/components/breadCrumb'
import CompanyConfiguration from './components/companyConfiguration'
import Webhook from './components/webhook'
import Integration from './components/integration'
import Signature from './components/signature'
import BaseDocument from './components/baseDocument'
import Columns from './components/columns'
import { getCompanyInfo, updateCompanyInfo } from '~/states/modules/companies'
import { getUserProfile } from '~/states/modules/session'
import styles from './index.module.scss'
import MainLayout from '~/components/mainLayout'

const Settings = () => {
	const { search } = useLocation()
	const searchParams = new URLSearchParams(search)

	const [breadCrumpCurrent, setBC] = useState('Colunas')
	const [current, setCurrent] = useState(searchParams.get('tab') ?? 'columns')

	const { companyInfo, loading } = useSelector(({ companies }) => companies)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getCompanyInfo())
	}, [dispatch])

	const handleSaveConfig = async (values) => {
		await dispatch(
			updateCompanyInfo({
				config: {
					...companyInfo.config,
					...Object.keys(values).reduce((acc, key) => {
						if (values[key] !== undefined) {
							acc[key] = values[key]
						}
						return acc
					}, {}),
				},
			})
		)
		dispatch(getUserProfile())
	}

	const { is_financial } = useSelector(({ session }) => session)

	const handleNav = (e) => {
		setCurrent(e.key)
		if (e.key === 'webhook') {
			setBC('Webhook')
		}
		if (e.key === 'companyConfiguration') {
			setBC('Empresa')
		}
		if (e.key === 'columns') {
			setBC('Colunas')
		}
	}

	const menuItems = [
		{
			key: 'columns',
			icon: <FileTextOutlined />,
			label: 'Colunas',
		},
		{
			key: 'companyConfiguration',
			icon: <FormOutlined />,
			label: 'Configurações da Empresa',
		},
		{
			key: 'webhook',
			icon: <NodeIndexOutlined />,
			label: 'Webhook',
		},
		{
			key: 'integration',
			icon: <DeploymentUnitOutlined />,
			label: 'Integração',
		},
		...(is_financial
			? [
					{
						key: 'signature',
						icon: <EditOutlined />,
						label: 'Planos e pagamentos',
					},
				]
			: []),
		{
			key: 'baseDocument',
			icon: <ArrowUpOutlined />,
			label: 'Documento base',
		},
	]

	return (
		<MainLayout selectedKey={'settings'}>
			<Layout style={{ backgroundColor: '#fff' }}>
				<PageHeader>
					<BreadCrumb parent="Configurações" current={breadCrumpCurrent} />
				</PageHeader>
				<Menu
					onClick={handleNav}
					selectedKeys={[current]}
					mode="horizontal"
					items={menuItems}
					style={{ display: 'flex' }}
				/>
				<Layout className={styles.content}>
					{current === 'columns' && (
						<Spin spinning={loading}>
							<Columns config={companyInfo?.config} onSave={handleSaveConfig} />
						</Spin>
					)}
					{current === 'companyConfiguration' && <CompanyConfiguration />}
					{current === 'webhook' && <Webhook />}
					{current === 'integration' && <Integration />}
					{current === 'signature' && <Signature />}
					{current === 'baseDocument' && <BaseDocument />}
				</Layout>
			</Layout>
		</MainLayout>
	)
}

export default Settings
